import { render, staticRenderFns } from "./AwardsSection.vue?vue&type=template&id=a90098d0&scoped=true&"
import script from "./AwardsSection.vue?vue&type=script&lang=js&"
export * from "./AwardsSection.vue?vue&type=script&lang=js&"
import style0 from "./AwardsSection.vue?vue&type=style&index=0&id=a90098d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90098d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
